let reduxStore;

export const registerAuthSessionStore = store => {
  reduxStore = store;
};

export const getAuthSession = () => reduxStore?.getState()?.authSession || {};

export const dispatchAuthSession = action => {
  if (!reduxStore) throw new Error("Auth session store has not been registered");
  return reduxStore.dispatch(action);
};
